import { render, staticRenderFns } from "./IconLike.vue?vue&type=template&id=3687caa8"
import script from "./IconLike.vue?vue&type=script&lang=js"
export * from "./IconLike.vue?vue&type=script&lang=js"
import style0 from "./IconLike.vue?vue&type=style&index=0&id=3687caa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports